import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DeviceTypeOption } from 'src/app/pages/device-register/models/device-type-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { deviceTypeOptionSelectors } from '../state/device-type-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: DeviceTypeSelectComponent,
        },
    ],
    selector: 'ndt-device-type-select',
    templateUrl: './device-type-select.component.html',
    standalone: false
})
export class DeviceTypeSelectComponent extends LcsSingleSelectBase<DeviceTypeOption> implements OnInit {
   deviceTypes: Observable<DeviceTypeOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.deviceTypes = this.store.pipe(select(deviceTypeOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: DeviceTypeOption | null): string | null {
      return item ? item.name : null;
   }

   trackBy(item: DeviceTypeOption | null) {
      return item ? item.deviceTypeId : null;
   }
}
